<template>
  <tg-layout>
    <template slot="header">
      <el-row type="flex" justify="space-between">
        <tg-search-tool @on-submit="handleSearch">
          <tg-dropdown
            :items="dropdownTarget"
            @on-change="handleChangeTargetTo"
            trigger="click"
          >
            <template slot="icon"></template>
          </tg-dropdown>
          <tg-dropdown
            :items="dropdown"
            @on-change="handleChange"
            trigger="click"
            v-show="searchData.target_to != ''"
          >
            <template slot="icon"></template>
          </tg-dropdown>
          <tg-date-search
            ref="dateSearch"
            size="small"
            v-model="dateRange"
            oneYearLimit
          ></tg-date-search>
          <el-input
            :placeholder="$t('component.form.input.placeholder.activity')"
            v-model="searchData.activity_name"
            class="tg-input"
            size="small"
            style="width: 220px"
            clearable
          ></el-input>
          <template slot="right"></template>
        </tg-search-tool>
        <el-row
          type="flex"
          justify="start"
          align="middle"
          style="font-size: 14px"
        >
          <i class="tg-icon-total_of_activity tg-icon"></i>
          <label>{{ $t("column.total_of_activity") }}:</label>
          <label style="color: #1168a8"
            >{{ total_of_activity }}{{ $t("unit.gear") }}</label
          >
        </el-row>
      </el-row>
    </template>
    <tg-table
      ref="table"
      :columns="currentColumns"
      :proxy="proxy"
      align="center"
      :fit="true"
      showPagination
      @on-loaded="handleLoaded"
      @cell-click="handleCellClick"
      :cell-class-name="parseCellClass"
    >
      <template slot="activity_target" slot-scope="scope">
        <span>{{$t('enum.target_to[' +scope.row.target_to+ ']')}}</span>
      </template>

      <template slot="activity_class" slot-scope="scope">
        <span>{{$t('enum.event_type[' +scope.row.category_id+ ']')}}</span>
      </template>

      <template
        v-slot:activity_name="scope"
        :class="{ 'cursor-pointer': scope.row.total_of_apply > 0 }"
      >
        <span :class="{ 'as-link': scope.row.total_of_apply > 0 }">{{
          scope.value
        }}</span>
      </template>
      <template slot="total_of_apply" slot-scope="scope">
        <span>{{ scope.formated }}</span>
      </template>
      <template slot="check_success" slot-scope="scope">
        <span>{{ scope.formated }}</span>
      </template>
      <template slot="check_fail" slot-scope="scope">
        <span>{{ scope.formated }}</span>
      </template>
      <template slot="range_time" slot-scope="scope">
        <span>{{ scope.row.allow_duration_start }}</span>
        <br />
        <span>{{ scope.row.allow_duration_end }}</span>
      </template>
    </tg-table>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgDateSearch from "@/components/datePicker/TgDateSearch";
import TgTable from "@/components/table/TgTable";
import TgSearchTool from "@/components/tool/TgSearchTool";
import TgDropdown from "@/components/dropdown/TgDropdown";
import date from "@/utils/date";
import apis from "@/apis";
const api = apis.activity.board;

export default {
  components: {
    TgLayout,
    TgDateSearch,
    TgTable,
    TgSearchTool,
    TgDropdown,
  },
  data() {
    return {
      proxy: api.getData,
      dateRange: {},
      columns: [],
      class: [],
      currentColumns: [],
      dropdownTarget: [], //存放活動類別之下拉選單
      dropdown: [], //存放活動類別之下拉選單
      total_of_activity: 0,
      searchData: {
        target_to: "",
        activity_class: "", //查詢時的活動類別id
        activity_name: "", //查詢的活動名稱
      },
      isSearch: false,
    };
  },
  props: {
    hasUser: Boolean,
  },
  created() {
    if (this.$route.params.username) {
      this.$router.push({ name: "activity.record.board.index" });
    }

    this.$store.commit("breadcrumb/clear"); //清空麵包屑

    api.getColumns().then((response) => {
      this.currentColumns = response.data.columns;
      this.$nextTick(() => {
        this.$refs.table.init(this.request);
      });
    });
  },
  computed: {
    //按下【查詢】時將時間和其他查詢資料合併送出
    request() {
      return { ...this.searchData, ...this.dateRange };
    },
    usernameLang() {
      if (!this.groupTag) {
        return "column.userfullname";
      }
      return "column." + this.groupTag + "_account";
    },
  },
  methods: {
    renderHeader(h) {
      return h("span", this.$t(this.usernameLang));
    },
    handleLoaded(response) {
      if(response.retcode == 0){
        this.total_of_activity = response.total_of_activity;
        if (this.class.length == 0) {
          this.class = response.class;
        }

        if (this.dropdownTarget.length == 0) {
          this.dropdownTarget = this.parseDropdown(response.target_to);
        }

        if (this.dropdown.length == 0) {
          this.dropdown = this.parseDropdown(this.class[1]);
        }
      }
    },
    parseCellClass({ row, column }) {
      if (column.columnKey == "activity_name" && row.total_of_apply > 0) {
        return "clickable";
      }
    },
    handleCellClick(row, col) {
      if (col.columnKey == "activity_name" && row.total_of_apply > 0) {
        if (this.$user.group == 20) {
          let routeName = "activity.record.detail";
          this.$router.push({
            name: routeName,
            params: {
              activity_id: row.activity_id,
              target_name: this.$user.username,
            },
          });
        } else {
          let routeName = "activity.record.agent";
          this.$router.push({
            name: routeName,
            params: {
              activity_id: row.activity_id,
              activity_name: row.activity_name,
            },
          });
        }
      }
    },
    handleSearch() {
      this.isSearch = !!this.searchData.activity_name;
      this.$refs.table.search(this.request);
    },
    handleChangeTargetTo(item) {
      //變更篩選類別項目
      this.selected = item;
      if (item.value == "") {
        this.searchData.activity_class = "";
      } else {
        this.dropdown = this.parseDropdown(this.class[item.value]);
      }
      this.searchData.target_to = item.value;
    },
    handleChange(item) {
      //變更篩選類別項目
      this.selected = item;
      this.searchData.activity_class = item.value;
    },
    parseReqeustTime(value) {
      if (!value) {
        return "";
      }

      let year = date.format(value, "YYYY");
      value = date.format(value, "YYYY-MM-DD");

      if (year < 2018) {
        return "2017-12-31 "+this.$t("enum.before");
      } else {
        return value;
      }
    },
    requestTimeisToday(value) {
      if (!value) {
        return false;
      }

      return date.isSame(date.format(value, "YYYY-MM-DD"), date.today());
    },
    parseDropdown(dropdown) {
      return dropdown.map((item) => {
        return {
          label: item.name,
          value: item.id,
        };
      });
    },
  },
};
</script>
